export const ROOT_PATH = '/life-insurance';
export const APPLICATION_PATH = 'application';
export const APPLICATION_IN_PROGRESS_PATH = 'application-in-progress';
export const PERMANENT_POLICY_APPLICATION_PATH = 'permanent-policy-application';
export const QUOTE_FINDER_PATH = 'quotes';
export const PARTNERS_PATH = 'partners';
export const PROGRESSIVE_PATH = 'progressive';
export const ESTIMATES_PATH = 'estimates';
export const START_PATH = 'start';
export const MOTIVATIONS_PATH = 'motivations';

export const START_FULL_PATH = `${ROOT_PATH}/${START_PATH}`;

// Basics Routes
export const BASICS_PATH = 'basics';
export const INFO_PATH = 'info';
export const HOUSEHOLD_PATH = 'household';
export const SPOUSAL_PATH = 'sp'; // MLD-1 - Remove if Life Spousal Self Serve loses

export const SPOUSAL_INFO_PATH = 'sp-info'; // MLD-137 - Remove if Life Spousal Self Serve V2 loses

export const BASICS_BASE_PATH = `${ROOT_PATH}/${BASICS_PATH}`;

// Full paths for /basics routes
export const INFO_FULL_PATH = `${BASICS_BASE_PATH}/${INFO_PATH}`;
export const HOUSEHOLD_FULL_PATH = `${BASICS_BASE_PATH}/${HOUSEHOLD_PATH}`;
export const SPOUSAL_FULL_PATH = `${BASICS_BASE_PATH}/${SPOUSAL_PATH}`;
export const SPOUSAL_INFO_FULL_PATH = `${BASICS_BASE_PATH}/${SPOUSAL_INFO_PATH}`;

// Health Profile Routes
export const HEALTH_PATH = 'health';
export const HEALTH_PROFILE_PATH = 'wh1uzus0';
export const MEDICAL_CONDITIONS_PATH = '26sreqm5';
export const ASTHMA_PROFILE_PATH = 'sg185hay';
export const CANCER_PROFILE_PATH = 'b42iv4zj';
export const DEPRESSION_PROFILE_PATH = 'h7bkv00b';
export const DIABETES_PROFILE_PATH = '1f2pcrwq';
export const HEART_ATTACK_PROFILE_PATH = 'heuixadz';
export const SLEEP_APNEA_PROFILE_PATH = '24wk53g4';
export const STROKE_PROFILE_PATH = 'edydihjy';
export const TOBACCO_PROFILE_PATH = 'bl3f9y8z';
export const HEALTH_LIFESTYLE_PATH = 'health-lifestyle';
export const PRUDENTIAL_QUOTATION_PATH = 'prudential-quotation';

export const HEALTH_PROFILE_BASE_PATH = `${ROOT_PATH}/${HEALTH_PATH}`;

// Full paths for /health routes
export const ASTHMA_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${ASTHMA_PROFILE_PATH}`;
export const CANCER_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CANCER_PROFILE_PATH}`;
export const DEPRESSION_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${DEPRESSION_PROFILE_PATH}`;
export const DIABETES_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${DIABETES_PROFILE_PATH}`;
export const HEALTH_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEALTH_PROFILE_PATH}`;
export const HEART_ATTACK_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEART_ATTACK_PROFILE_PATH}`;
export const SLEEP_APNEA_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${SLEEP_APNEA_PROFILE_PATH}`;
export const STROKE_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${STROKE_PROFILE_PATH}`;
export const TOBACCO_PROFILE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${TOBACCO_PROFILE_PATH}`;
export const HEALTH_LIFESTYLE_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEALTH_LIFESTYLE_PATH}`;
export const PRUDENTIAL_QUOTATION_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${PRUDENTIAL_QUOTATION_PATH}`;

// Full path for motivations route
export const MOTIVATIONS_FULL_PATH = `${ROOT_PATH}/${MOTIVATIONS_PATH}`;

// Full path for partners route
export const PARTNERS_FULL_PATH = `${ROOT_PATH}/${PARTNERS_PATH}`;
export const PROGRESSIVE_FULL_PATH = `${ROOT_PATH}/${PROGRESSIVE_PATH}`;

// Full path for Estimates route
export const ESTIMATES_FULL_PATH = `${ROOT_PATH}/${ESTIMATES_PATH}`;

// Full paths for application routes
export const APPLICATION_FULL_PATH = `${ROOT_PATH}/${APPLICATION_PATH}`;
export const APPLICATION_BENEFICIARIES_FULL_PATH = `${ROOT_PATH}/${APPLICATION_PATH}/beneficiaries`;
export const APPLICATION_IN_PROGRESS_FULL_PATH = `${ROOT_PATH}/${APPLICATION_IN_PROGRESS_PATH}`;
export const PERMANENT_POLICY_APPLICATION_FULL_PATH = `${ROOT_PATH}/${PERMANENT_POLICY_APPLICATION_PATH}`;
// MLD-201 - Remove if Multi-Product Whole Life loses
export const BASIC_WHOLE_LIFE_FULL_PATH = `${ROOT_PATH}/whole-life-protection`;

export const DASHBOARD_LIFE_PATH = '/dashboard/life';
export const DASHBOARD_CONFIRMATION_PATH = '/dashboard/life/confirmation';

export const REDIRECT_EVENT = 'redirect';
export const APPLIED_POLICY_REDIRECT_REASON = 'Restricted AU Applied Policy';

// Quotes Routes
export const QUOTES_BASE_PATH = `${ROOT_PATH}/quotes`;
export const QUOTES_START_PATH = 'start';
// Carrier Quotes Routes
export const BEST_FOR_YOU_FULL_PATH = `${ROOT_PATH}/best-for-you`;
export const MY_QUOTES_FULL_PATH = `${ROOT_PATH}/my-quotes`;
export const MY_QUOTES_NEXT_STEPS_PATH = 'next-steps';
export const MY_QUOTES_NEXT_STEPS_FULL_PATH = `${MY_QUOTES_FULL_PATH}/${MY_QUOTES_NEXT_STEPS_PATH}`;

// Sequential Interviews Routes
export const INTERVIEW_BASE_PATH = `${ROOT_PATH}/interview`;

// Banner MVP Routes
export const BANNER_MVP_ADDRESS_PATH = 'address';
export const BANNER_MVP_DRIVER_LICENSE_PATH = 'driver-license';
export const BANNER_MVP_DRIVING_HISTORY_PATH = 'qzqyl6ua';
export const BANNER_MVP_ALCOHOL_HISTORY_PATH = 'rs6q39cw';
export const BANNER_MVP_SOCIAL_SECURITY_PATH = 'social-security';
export const BANNER_MVP_EMPLOYMENT_PATH = 'employment';
export const BANNER_MVP_BIRTHPLACE_PATH = 'birthplace';
export const BANNER_MVP_POLICY_DETAILS_PATH = 'policy-details';
export const BANNER_MVP_APPLICATION_HISTORY_PATH = 'application-history';
export const BANNER_MVP_REVIEW_PATH = 'review';
export const BANNER_MVP_CARRIER_HANDOFF_PATH = 'carrier-handoff';
export const BANNER_HEALTH_HISTORY_PATH = `${ROOT_PATH}/interview/ded4c27d-671a-4729-928d-9db474d89755`;

// Client-led Referrals - Remove if Client-led Referral PgPro experiment loses
export const OFFBOARD_CLIENT_LED_REFERRAL_FULL_PATH = `${ROOT_PATH}/advisor-next-steps`;

export const APPLY_FULL_PATH = `${ROOT_PATH}/apply`;
export const PRUDENTIAL_IDENTITY_VERIFICATION_PATH = 'identity-verification';
export const PRUDENTIAL_IDENTITY_VERIFICATION_FULL_PATH = `${ROOT_PATH}/${PRUDENTIAL_IDENTITY_VERIFICATION_PATH}`;
export const RESIDENTIAL_ADDRESS_PATH = 'residential-address';
export const RESIDENTIAL_ADDRESS_FULL_PATH = `${ROOT_PATH}/${RESIDENTIAL_ADDRESS_PATH}`;

// Common App routes - HOUSE-1425
export const COMMON_APP_PATH = 'common-app';
export const COMMON_APP_PERSONAL_DETAILS_PATH = 'personal-details';
export const COMMON_APP_HOUSEHOLD_INFORMATION_PATH = 'household-information';
export const COMMON_APP_RESIDENCE_PATH = 'residence';
export const COMMON_APP_FINANCIAL_INFORMATION_PATH = 'financial-information';
export const COMMON_APP_APPLICATION_DETAILS_PATH = 'application-details';
export const COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_PATH = 'additional-coverage-options';
export const COMMON_APP_BENEFICIARIES_PATH = 'beneficiaries';
export const COMMON_APP_INSURANCE_HISTORY_PATH = 'insurance-history';
export const COMMON_APP_EMPLOYMENT_PATH = 'employment';
export const COMMON_APP_REVIEW_PATH = 'review';

export const COMMON_APP_PERSONAL_DETAILS_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_PERSONAL_DETAILS_PATH}`;
export const COMMON_APP_HOUSEHOLD_INFORMATION_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_HOUSEHOLD_INFORMATION_PATH}`;
export const COMMON_APP_RESIDENCE_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_RESIDENCE_PATH}`;
export const COMMON_APP_FINANCIAL_INFORMATION_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_FINANCIAL_INFORMATION_PATH}`;
export const COMMON_APP_APPLICATION_DETAILS_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_APPLICATION_DETAILS_PATH}`;
export const COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_PATH}`;
export const COMMON_APP_EMPLOYMENT_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_EMPLOYMENT_PATH}`;
export const COMMON_APP_BENEFICIARIES_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_BENEFICIARIES_PATH}`;
export const COMMON_APP_INSURANCE_HISTORY_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_INSURANCE_HISTORY_PATH}`;
export const COMMON_APP_REVIEW_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}/${COMMON_APP_REVIEW_PATH}`;

export const COMMON_APP_FULL_PATH = `${ROOT_PATH}/${COMMON_APP_PATH}`;

// Continue Online (Underwriting) routes - LIFE-3103
export const CONTINUE_ONLINE_PATH = 'underwriting';
export const CONTINUE_ONLINE_FULL_PATH = `${ROOT_PATH}/${CONTINUE_ONLINE_PATH}`;
export const CONTINUE_ONLINE_HEALTH_INTRO_PATH = 'health-intro';
export const CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH = 'fgpoc36v';
export const CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH = 'fs841xpu';
export const CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH = 'z6qse91p';
export const CONTINUE_ONLINE_ADD_ADHD_PATH = 'kit6y6om';
export const CONTINUE_ONLINE_ANXIETY_PATH = 'qhnjedgf';
export const CONTINUE_ONLINE_MARIJUANA_PATH = 'zf76rugq';
export const CONTINUE_ONLINE_ADVERSE_DRIVING_PATH = 'wpvwd6uv';
export const CONTINUE_ONLINE_SUBSTANCE_USE_PATH = 'i112llme';
export const CONTINUE_ONLINE_CITIZENSHIP_PATH = 'citizenship';
export const CONTINUE_ONLINE_CRIMINAL_HISTORY_PATH = 'vi83x6nj';
export const CONTINUE_ONLINE_MILITARY_SERVICE_PATH = '4ktvwig3';
export const CONTINUE_ONLINE_HAZARDOUS_ACTIVITIES_PATH = 'v0ua8oeu';
export const CONTINUE_ONLINE_FINANCES_PATH = 'finances';
export const CONTINUE_ONLINE_TRAVEL_PATH = 'travel';
export const CONTINUE_ONLINE_FAMILY_HISTORY_PATH = 'family-history'; // LIFE-3171 - move to Health section and rename if Underwriting Funnel Remix experiment wins
export const HEALTH_LIFESTYLE_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${HEALTH_LIFESTYLE_PATH}`;
export const MEDICAL_CONDITIONS_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${MEDICAL_CONDITIONS_PATH}`;
export const BLOOD_PRESSURE_DETAILS_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH}`;
export const CHOLESTEROL_DETAILS_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH}`;
export const ADD_ADHD_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_ADD_ADHD_PATH}`;
export const ANXIETY_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_ANXIETY_PATH}`;
export const PREGNANCY_HISTORY_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH}`;
export const FAMILY_HISTORY_HEALTH_FULL_PATH = `${HEALTH_PROFILE_BASE_PATH}/${CONTINUE_ONLINE_FAMILY_HISTORY_PATH}`;
// MLD-409 Remove if field uw updated loses
export const POLICY_REPLACEMENT_PATH = '7lmt32wq';
export const POLICY_OWNER_PATH = '4u7n9yyz';

// Full path for Field UW Updates
export const POLICY_REPLACEMENT_FULL_PATH = `${ROOT_PATH}/${POLICY_REPLACEMENT_PATH}`;
export const POLICY_OWNER_FULL_PATH = `${ROOT_PATH}/${POLICY_OWNER_PATH}`;

// Review Information route
export const REVIEW_INFORMATION_PATH = 'review-information';
export const REVIEW_INFORMATION_FULL_PATH = `${ROOT_PATH}/${REVIEW_INFORMATION_PATH}`;

// Full path for partners route
export const LIFESTYLE_PATH = 'lifestyle';
export const LIFESTYLE_FULL_PATH = `${ROOT_PATH}/${LIFESTYLE_PATH}`;
export const LIFESTYLE_TRAVEL_FULL_PATH = `${LIFESTYLE_FULL_PATH}/${CONTINUE_ONLINE_TRAVEL_PATH}`;

export const AI_ASSISTANT_PATH = 'ai-assistant';
export const AI_ASSISTANT_FULL_PATH = `${ROOT_PATH}/${AI_ASSISTANT_PATH}`;

// Prudential Routes
export const PRUDENTIAL_PATH = 'prudential';
export const PRUDENTIAL_INTERVIEW_PATH = 'interview';
export const PRUDENTIAL_INTERVIEW_BASE_PATH = `${ROOT_PATH}/${PRUDENTIAL_PATH}/${PRUDENTIAL_INTERVIEW_PATH}`;

export const EXISTING_INSURANCE_PATH = 'existing-insurance';
export const MEDICAL_PATH = 'medical';
export const WEIGHT_PATH = 'weight';

export const PRUDENTIAL_INTERVIEW_EXISTING_INSURANCE_FULL_PATH = `${PRUDENTIAL_INTERVIEW_BASE_PATH}/${EXISTING_INSURANCE_PATH}`;
export const PRUDENTIAL_INTERVIEW_MEDICAL_FULL_PATH = `${PRUDENTIAL_INTERVIEW_BASE_PATH}/${MEDICAL_PATH}`;
export const PRUDENTIAL_INTERVIEW_WEIGHT_FULL_PATH = `${PRUDENTIAL_INTERVIEW_BASE_PATH}/${WEIGHT_PATH}`;
export const PRUDENTIAL_CONSENT_PATH = 'consent';
export const PRUDENTIAL_CONSENT_FULL_PATH = `${ROOT_PATH}/${PRUDENTIAL_PATH}/${PRUDENTIAL_CONSENT_PATH}`;
export const PRUDENTIAL_TOBACCO_PATH = 'tobacco';
export const PRUDENTIAL_TOBACCO_FULL_PATH = `${PRUDENTIAL_INTERVIEW_BASE_PATH}/${PRUDENTIAL_TOBACCO_PATH}`;
